<template>
  <div class="c-game-modal">
    <el-select
      :value="gameName"
      :style="{ width: `${width}px` }"
      :placeholder="placeholder"
      :disabled="disabled"
      popper-class="c-visibility-hidden"
      :size="size"
      multiple
      clearable
      collapse-tags
      @remove-tag="remove"
      @clear="gameClear"
      @focus="visible = true"
    >
      <span slot="empty"></span>
    </el-select>

    <!-- 游戏选择弹窗 -->
    <Modal
      v-model="visible"
      title="选择游戏"
      :width="1000"
      :closable="false"
      :mask-closable="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <Row :gutter="20">
        <Col span="24">
          <selecter
            ref="gameSelect"
            v-model="mult_game"
            :data="gameData"
            :max="max"
            :title="['游戏组', '游戏']"
            search
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="handleClear"
          />
        </Col>
      </Row>
      <Row slot="footer" :gutter="12">
        <Button type="default" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import { isArray, deepCopy, getIdOfData, getNameOfData } from '@/common/js/utils'
import Selecter from './select/selecter.vue'

export default {
  name: 'GameModal',
  components: { Selecter },
  props: {
    value: {
      type: Array,
      required: true
    },
    gameData: {
      type: Array
    },
    width: {
      type: Number,
      default: 180
    },
    max: {
      type: Number
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    size: {
      type: String,
      default: 'mini'
    }
  },
  computed: {
    gameId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    gameName() {
      return this.gameInfo.map((ret) => ret.name || ret)
    },
    gameInfo() {
      let game = []
      if (isArray(this.value)) {
        game = this.value.map((id) => {
          const item = getIdOfData(this.gameData, id)
          return item || id
        })
      }
      return game
    }
  },
  data() {
    return {
      loading: null,
      visible: null,
      mult_game: []
    }
  },
  methods: {
    bindGetData(val) {
      if (!this.mult_game.length) {
        if (val) {
          this.mult_game = deepCopy(
            this.gameInfo.map((ret) => {
              return { key: ret.id, name: ret.name }
            })
          )
        } else {
          this.$refs.gameSelect.updateResource()
          this.clear()
        }
      }
    },
    gameClear() {
      this.$emit('input', [])
      this.handleClear()
    },
    clear() {
      this.gameData.forEach((ret) => {
        this.selectAll({ list: this.gameData, check: false, id: ret.id })
      })
    },
    // 全选
    selectAll({ list, check = true, current = '', id, keyword }) {
      let data
      if (id) {
        const item = getIdOfData(list, id)
        item && (data = [item])
      } else if (current) {
        const item = getNameOfData(list, current)
        item && (data = [item])
      } else if (keyword) data = list.filter((ret) => ret.name.toLowerCase().includes(keyword))
      else data = list
      isArray(data) &&
        data.forEach((ret) => {
          if (ret.children && ret.children.length) {
            const childs = keyword && id ? ret.children.filter((met) => met.name.toLowerCase().includes(keyword)) : ret.children
            childs.map((rec) => {
              this.$set(rec, 'check', check)
              this.checkItem(Object.assign(rec, { check, key: rec.id }))
              return rec
            })
          } else {
            this.$set(ret, 'check', check)
            this.checkItem(Object.assign(ret, { check, key: ret.id }))
          }
        })
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getIdOfData(list, name)
      if (data.children && data.children.length) this.selectAll({ list, check: false, current: data.value })
      else this.$set(data, 'check', false)
      const index = this.mult_game.findIndex((ret) => ret.key === name)
      index > -1 && this.mult_game.splice(index, 1)
    },
    handleClear() {
      this.mult_game = []
      this.clear()
    },
    remove(tag) {
      const clearData = (tag, data) => {
        if (!isArray(data)) return
        data.some((ret) => {
          if (!isArray(ret.children)) {
            ret.name === tag && this.$set(ret, 'check', false)
            return ret.name === tag
          } else return clearData(tag, ret.children)
        })
      }
      clearData(tag, this.gameData) // 单清选择
      const index = this.mult_game.findIndex((ret) => ret.name === tag)
      index > -1 && this.mult_game.splice(index, 1) // 单清结果
      this.save()
    },
    checkItem(params) {
      const { key, check } = params
      const isDul = this.mult_game.some((ret) => ret.key === key) // 查重

      if (check && !isDul) this.mult_game.push(params)
      else if (!check && isDul) {
        const index = this.mult_game.findIndex((ret) => ret.key === key)
        index > -1 && this.mult_game.splice(index, 1)
      }
    },
    save() {
      const ids = this.mult_game.map((ret) => ret.key)
      if (this.max < ids.length) return
      this.$emit('input', ids)
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-game-modal {
  position: relative;
}
</style>
